import { render, staticRenderFns } from "./NavItemSquare.vue?vue&type=template&id=c43e8faa&scoped=true&"
import script from "./NavItemSquare.vue?vue&type=script&lang=js&"
export * from "./NavItemSquare.vue?vue&type=script&lang=js&"
import style0 from "./NavItemSquare.vue?vue&type=style&index=0&id=c43e8faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43e8faa",
  null
  
)

export default component.exports